// extracted by mini-css-extract-plugin
module.exports = {"aiccSection":"AICC_aiccSection__3ntxh","paragraph":"AICC_paragraph__9HvQI","subUsers":"AICC_subUsers__14iGP","subUserLink":"AICC_subUserLink__3Id3L"};